import axios from 'axios';

const { apiHost = '' } = window.waselConfig || {};
const waselAPI = axios.create({ baseURL: `${apiHost}/` });

export default waselAPI;
